export const parseClaims = jwt => {
    if (!jwt || typeof jwt !== 'string') {
        throw new TypeError('Invalid jwt');
    }

    const {JSON, atob} = window;

    const jwtSegments = jwt.split('.');

    if (jwtSegments.length !== 3) {
        throw new TypeError('Invalid jwt format');
    }

    return JSON.parse(
        atob(
            jwtSegments[1],
        ),
    );
};
